export default __webpack_public_path__ + "static/media/pdpa-fillable.fcf2a8e0.pdf";